
<template>
   <div class="home">
       <Chart/>
         <!-- <div class="footer"> 奇蚁科技 版权所有     客服电话：4008509168</div> -->
   </div>
</template>

<script>
import Chart from './Chart.vue'

export default {
    components:{
        Chart
    },
    data(){
        return {
            msg:''
        }
    },
    created(){
    },
    methods:{
        init(){

  
        }
    }

}
</script>

<style scoped>
.home{
    height: 100%;
}

.content{
    /* background: linear-gradient(to bottom, #12006a, #1531C4); */
}
.footer{
  background: rgb(9, 22, 88);
  text-align: center;
  color: #babde5;
   padding-bottom:30px ;
   font-size: 16px;

  
}
</style>